import React, { FC } from 'react';
import { FilterModel } from '../../../common/model/ui/filter.model';
import OvListFilter from './OvListFilter';
import { hasAppliedListFilters } from '../../../common/utils/helpers';
import { UserInfoFields } from '../../../firebase/document-field.enums';
import { FilterType } from '../../../common/model/ui/filter.type';
import { ClinicRole } from '../../../common/model/type/clinic-role';

interface OvClinicLocationProviderSearchFilterProps {
  removeFilters: () => void;
  onHandleFilterValueChange: (filter: FilterModel) => void;
  filterValues: {
    clinicRole: string;
    shouldHideNotRegisteredUsers: string;
  };
}

const OvClinicLocationProviderSearchFilter: FC<
  OvClinicLocationProviderSearchFilterProps
> = ({ removeFilters, onHandleFilterValueChange, filterValues }) => {
  const filters: FilterModel[] = [
    {
      fieldName: UserInfoFields.clinic_role,
      label: 'common.userFields.clinicRole',
      type: FilterType.select,
      options: [
        {
          label: 'common.clinicLocations.clinicRoleValues.physician',
          value: ClinicRole.Physician,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.nursePractitioner',
          value: ClinicRole.NursePractitioner,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.nurse',
          value: ClinicRole.Nurse,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.medicalAssistant',
          value: ClinicRole.MedicalAssistant,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.administrative',
          value: ClinicRole.Administrative,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.dietitian',
          value: ClinicRole.Dietitian,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.acupuncturist',
          value: ClinicRole.Acupuncturist,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.healthCoach',
          value: ClinicRole.HealthCoach,
          translate: true,
        },
        {
          label: 'common.clinicLocations.clinicRoleValues.doctor',
          value: ClinicRole.Doctor,
          translate: true,
        },
      ],
      value: filterValues.clinicRole,
    },
    {
      fieldName: UserInfoFields.should_hide_not_registered_users,
      label: 'common.userSearchFilters.shouldHideNotRegisteredUsers',
      type: FilterType.radio,
      options: [
        {
          label: 'common.actions.yes',
          value: true,
        },
        {
          label: 'common.actions.no',
          value: false,
        },
        {
          label: 'common.actions.notSelected',
          value: '',
        },
      ],
      value: filterValues.shouldHideNotRegisteredUsers,
    },
  ];

  return (
    <OvListFilter
      filters={filters}
      isOpened={true}
      hasAppliedFilters={hasAppliedListFilters(filters)}
      onRemoveFilters={removeFilters}
      onHandleFilterValueChange={onHandleFilterValueChange}
    />
  );
};

export default OvClinicLocationProviderSearchFilter;
